export
const name: string = "HudControls";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform float u_id;
`;

export
const varyings: string = ``;

export
const implementation: string = `
    void main()
    {
        gl_FragColor = intToVec4(u_id);
    }
`;


